<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
data() {
  return {
    errors: {},
    title: "Sales",
    text: "Sales",
    text1: "Quotations",
    toast: useToast(),
    quotation: [],
    admin: [],
    banks: [],
    previewData: null
  };
},

 created() {
  this.loadPreviewData();
 },

methods: {

 loadPreviewData(){
  const previewId = this.$route.params.id;
  const storedData = sessionStorage.getItem(`preview_${previewId}`);

  if(storedData){
   this.previewData = JSON.parse(storedData);
   // Optionally remove from storage after loading
   sessionStorage.removeItem(`preview_${previewId}`);
   this.adminDetail(this.clientAdmin.id);
   this.adminBanks(this.clientAdmin.id);
  }

  console.log(this.previewData.items);

 },   

 async adminDetail(admin_id){
  try{
   const response = await axios.get(`admin/${admin_id}`);
   this.admin = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

 async adminBanks(admin_id){
  try{
   const response = await axios.get(`banks/${admin_id}`);
   this.banks = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

},

};
</script>

<template>
 <div class="content mt-2 mb-3">
  
  <!-- Invoices -->
<div style="width:210mm; min-height:297mm; margin:auto; padding:20px; box-sizing:border-box; border:1px solid #ccc;">

  <!-- Header -->
  <table style="width:100%; border-collapse:collapse; border:1px solid #ddd;">
    <tr>
      <th colspan="2" style="font-size:20px; font-weight:600; text-align:center; background:#444; color:#fff; padding:10px; letter-spacing:1px;"> QUOTATION</th>
    </tr>
    <tr>
      <td style="width:40%; padding:10px; border:1px solid #ddd; vertical-align:top;">
        <img :src="admin.company?.logo_url" :alt="admin.company?.company_name" style="width:180px; height:auto; margin-bottom:6px;"><br>
      </td>
      <td style="width:60%; padding:10px; border:1px solid #ddd; text-align:right; vertical-align:top; line-height:1.5;">
        <h2 style="margin:0; font-size:18px; color:#222;">{{ admin?.company?.company_name }}</h2>
        <p v-if="admin?.company?.gst" style="margin:2px 0;">GSTIN: <strong>{{ admin?.company?.gst }}</strong></p>
        <p style="margin:2px 0;">ISO 9001:2015 CERTIFIED COMPANY</p>
        <p style="margin:2px 0;">Email: <strong>{{ admin?.company?.email }}</strong></p>
        <p style="margin:2px 0;">{{ admin?.company?.address }} {{ admin?.company?.city }}, {{ admin?.company?.state }} {{ admin?.company?.country }} - {{ admin?.company?.pincode }}</p>
        <p v-if="admin?.company?.mobile" style="margin:2px 0;">Phone: <strong>{{ admin?.company?.mobile }}</strong></p>
      </td>
    </tr>
    <tr>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Name:</strong> {{ previewData.to_name }}</p>
        <p style="margin:2px 0;" v-if="previewData.to_pincode"><strong>Address:</strong> {{ previewData.to_address }}, {{ previewData.to_city }}, {{ previewData.to_state }}, {{ previewData.to_country }} - {{ previewData.to_pincode }}</p>
        <p style="margin:2px 0;" v-if="previewData.to_email"><strong>Email:</strong> {{ previewData.to_email }}</p>
        <p style="margin:2px 0;" v-if="previewData.to_phone"><strong>Phone:</strong> {{ previewData.to_phone }}</p>
        <p style="margin:2px 0;" v-if="previewData.gst_no"><strong>GSTIN:</strong> {{ previewData.gst_no }}</p>
      </td>
      <td style="padding:10px; border:1px solid #ddd; vertical-align:top; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Quotation No:</strong> {{ previewData.quotation_number }}</p>
        <p style="margin:2px 0;"><strong>Date:</strong> {{ $formatDate(previewData.quotation_date, 'DD MMM YYYY') }}</p>
        <p style="margin:2px 0;"><strong>Sales Person:</strong> {{ auth?.name }}</p>
        <p style="margin:2px 0;"><strong>Contact:</strong> {{ auth?.mobile }}</p>
        <p style="margin:2px 0;"><strong>Email:</strong> {{ auth?.email }}</p>
      </td>
    </tr>
    <tr>
      <td colspan="2" style="padding:10px; border:1px solid #ddd; text-align:left; line-height:1.5;">
        <p style="margin:2px 0;"><strong>Subject:</strong> {{ previewData.subject }}</p>
       <div class="dynamic"> 
        <strong>Summary:</strong>
        <div v-html="previewData.summary"></div>
       </div>
      </td>
    </tr>
  </table>

  <!-- Product Table -->
<!-- ══ DIMENSIONAL ITEMS ══ -->
<template v-if="previewData?.items?.filter(r => r.calculation_type === 'dimensional').length">
  <div style="background:#f5f5f5; padding:7px 14px; font-size:11.5px; font-weight:700; color:#2c3e50; text-transform:uppercase; letter-spacing:0.8px; border:1px solid #e0e0e0; border-bottom:none; margin-top:14px;">
    Dimensional Items
  </div>
  <table style="width:100%; border-collapse:collapse;">
    <thead>
      <tr style="background:#2c3e50; color:#fff;">
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:5%;">S.No.</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:28%;">Title</th>
        <!-- <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:10%;">Image</th> -->
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:10%;">HSN/SAC</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:8%;">Unit</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:10%;">Rate</th>
        <th v-if="previewData.tax_mode === 'Item'" style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:8%;">Tax</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:10%;">Amount</th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(row, index) in previewData.items.filter(r => r.calculation_type === 'dimensional')" :key="'d-'+index">
        <!-- Main Row -->
        <tr :style="index % 2 === 1 ? 'background:#f9f9f9;' : ''">
          <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px;">{{ index + 1 }}</td>
          <td style="border:1px solid #e0e0e0; padding:8px 10px; font-size:12px; line-height:1.5; vertical-align:middle;">
            <strong>{{ row.name }}</strong>
            <div v-if="row.description" v-html="row.description" class="dynamic"></div>
          </td>
          <!-- <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; vertical-align:middle;">
            <img :src="$clientImage(row.image, 'items', clientAdmin)" style="width:70px; height:70px; object-fit:cover; border:1px solid #ddd; border-radius:4px;">
          </td> -->
          <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.hsn_code ?? 'N/A' }}</td>
          <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.unit }}</td>
          <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ parseFloat(row.price || 0).toFixed(2) }}</td>
          <td v-if="previewData.tax_mode === 'Item'" style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.taxName }}</td>
          <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;"><strong>{{ parseFloat(row.totalWithTax || 0).toFixed(2) }}</strong></td>
        </tr>
        <!-- Dimension Sub-Table Row -->
        <tr v-if="row.dimensions && row.dimensions.length">
          <td :colspan="previewData.tax_mode === 'Item' ? 8 : 7" style="padding:6px 10px 10px 20px; background:#f9f9f9; border:1px solid #e0e0e0;">
            <table style="width:100%; border-collapse:collapse; font-size:11.5px;">
              <thead>
                <tr style="background:#dce3ea; color:#2c3e50;">
                  <th style="padding:5px 8px; border:1px solid #ccc; text-align:center;">Qty</th>
                  <th style="padding:5px 8px; border:1px solid #ccc; text-align:center;">Width (mm)</th>
                  <th style="padding:5px 8px; border:1px solid #ccc; text-align:center;">Height (mm)</th>
                  <th style="padding:5px 8px; border:1px solid #ccc; text-align:center;">Size</th>
                  <th style="padding:5px 8px; border:1px solid #ccc; text-align:right;">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dim, di) in row.dimensions" :key="'dim-'+di">
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:center;">{{ dim.quantity }}</td>
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:center;">{{ parseFloat(dim.width).toFixed(2) }}</td>
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:center;">{{ parseFloat(dim.height).toFixed(2) }}</td>
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:center;">{{ parseFloat(dim.size).toFixed(4) }}</td>
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:right;">{{ parseFloat(dim.amount).toFixed(2) }}</td>
                </tr>
                <!-- Totals row -->
                <tr style="background:#eef1f4; font-weight:700;">
                  <td colspan="2" style="padding:4px 8px; border:1px solid #ddd; text-align:right; color:#2c3e50;">Total</td>
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:center;">{{ row.qty }}</td>
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:center;">{{ parseFloat(row.size || 0).toFixed(4) }}</td>
                  <td style="padding:4px 8px; border:1px solid #ddd; text-align:right;">{{ parseFloat(row.totalWithTax || 0).toFixed(2) }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<!-- ══ STANDARD ITEMS ══ -->
<template v-if="previewData?.items?.filter(r => r.calculation_type !== 'dimensional').length">
  <div style="background:#f5f5f5; padding:7px 14px; font-size:11.5px; font-weight:700; color:#2c3e50; text-transform:uppercase; letter-spacing:0.8px; border:1px solid #e0e0e0; border-bottom:none; margin-top:14px;">
    Standard Items
  </div>
  <table style="width:100%; border-collapse:collapse;">
    <thead>
      <tr style="background:#2c3e50; color:#fff;">
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:5%;">S.No.</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:26%;">Title</th>
        <!-- <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:9%;">Image</th> -->
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:9%;">HSN/SAC</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:7%;">Unit</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:9%;">Price</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:6%;">Qty</th>
        <th v-if="previewData.tax_mode === 'Item'" style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:7%;">Tax</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:9%;">Sub Total</th>
        <th style="padding:8px 10px; font-size:11.5px; border:1px solid #3d5166; text-align:center; width:9%;">Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in previewData.items.filter(r => r.calculation_type !== 'dimensional')" :key="'s-'+index" :style="index % 2 === 1 ? 'background:#f9f9f9;' : ''">
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px;">{{ index + 1 }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; font-size:12px; line-height:1.5; vertical-align:middle;">
          <strong>{{ row.name }}</strong>
          <div v-if="row.description" v-html="row.description" class="dynamic"></div>
        </td>
        <!--  <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; vertical-align:middle;">
          <img :src="$clientImage(row.image, 'items', clientAdmin)" style="width:70px; height:70px; object-fit:cover; border:1px solid #ddd; border-radius:4px;">
        </td> -->
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.hsn_code ?? 'N/A' }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.unit }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;">{{ parseFloat(row.price || 0).toFixed(2) }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.qty }}</td>
        <td v-if="previewData.tax_mode === 'Item'" style="border:1px solid #e0e0e0; padding:8px 10px; text-align:center; font-size:12px; vertical-align:middle;">{{ row.taxName }}</td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;"><strong>{{ row.amount }}</strong></td>
        <td style="border:1px solid #e0e0e0; padding:8px 10px; text-align:right; font-size:12px; vertical-align:middle;"><strong>{{ parseFloat(row.totalWithTax || 0).toFixed(2) }}</strong></td>
      </tr>
    </tbody>
  </table>
</template>

  <!-- Terms -->
  <div v-if="previewData.terms" style="margin-top:15px; border:1px solid #e0e0e0;">
    <div style="background:#2c3e50; padding:8px 14px; font-size:11.5px; font-weight:700; color:#fff; text-transform:uppercase; letter-spacing:0.8px;">
      Terms &amp; Conditions
    </div>
    <div style="padding:14px 18px; font-size:11.5px; color:#444; line-height:1.9; background:#fafbfc;" class="dynamic terms-content">
      <div v-html="previewData.terms"></div>
    </div>
  </div>

  <!-- Bank Details -->
  <table style="width:100%; border-collapse:collapse; margin-top:15px;">
    <tr>
      <th colspan="3" style="border:1px solid #ddd; padding:10px; text-align:left; background:#f2f2f2;">
        <u>BANK DETAILS</u>
      </th>
    </tr>
    <tr>

      <td style="border:1px solid #ddd; padding:10px; width:50%; vertical-align:top; line-height:1.6;" v-for="row in banks">
        <strong>{{row.name}}</strong><br>
        A/C Holder: {{row.account_holder_name}}<br>
        A/C No: {{row.account_no}}<br>
        IFSC: {{row.ifsc}}<br>
        Branch: {{row.branch}}<br>
        <img :src="$clientImage(row.image, 'banks', admin)" width="100" />
      </td>
    </tr>
  </table>

<div style="display:flex;justify-content: space-around;margin-top:25px;" class="dynamic">
<div style="width:70%">
 <h5 style="margin-bottom: 1rem;" v-if="previewData.notes">Notes:</h5> 
   <div v-html="previewData.notes"></div>
</div>
<div style="width:30%">  
  <!-- Signature -->
  <div style="text-align:right; line-height:1.6;">
    <img :src="$clientSignature(admin.company?.signature, admin)" style="width:120px; height:auto; margin-bottom:5px;"><br>
    <strong style="font-size:15px;">Authorised Signatory</strong><br>
    <span>On behalf of {{admin.company?.company_name}}</span>
  </div>
</div>
</div>


</div>
  <!-- /Invoices -->

    <!-- <div class="d-flex justify-content-center align-items-center mb-4">
      <a href="javascript:void(0);" class="btn btn-primary d-flex justify-content-center align-items-center me-2"><i class="ti ti-printer me-2"></i>Print Invoice</a>
      <a href="javascript:void(0);" class="btn btn-white d-flex justify-content-center align-items-center border"><i class="ti ti-copy me-2"></i>Clone Invoice</a>
    </div> -->
  </div>


</template>

<style scoped>
.terms-content :deep(p) {
  margin: 0 0 6px;
}
.terms-content :deep(ul),
.terms-content :deep(ol) {
  margin: 4px 0 8px 18px;
  padding: 0;
}
.terms-content :deep(li) {
  margin-bottom: 3px;
  list-style: auto !important;
}
.terms-content :deep(strong),
.terms-content :deep(b) {
  color: #2c3e50;
}
</style>